module.exports = __webpack_public_path__ + "img/skateboard.d3be0fe1.png";